export default class Environment {
    private static _hostField: string = window.location.host;

    protected static set hostField(value: string) {
        Environment._hostField = value;
    };

    protected static get hostField(): string {
        return Environment._hostField;
    };

    public static readonly prodEnvironmentBaseUrl: string = 'checkout.pay.amazon.dev';
    public static readonly prodEnvironmentBaseUrlMarketingSite: Array<string> = ['pay.amazon.com', 'pay.amazon.co.uk','pay.amazon.de', 'pay.amazon.fr', 'pay.amazon.it', 'pay.amazon.es', 'pay.amazon.eu', 'pay.amazon.co.jp'];

    // The prod distribution's own CloudFront domain is publicly reachable, and
    // `checkout.pay.amazon.dev` has no DNS record, so without this a page loaded from the
    // raw domain fell through to the *devo* pool and *devo* API — meaning devo identity
    // changes had prod-visible effect, and vice versa.
    public static readonly prodEnvironmentCloudFrontDomain: string = 'd13yxsd4rofb59.cloudfront.net';
    public static readonly prodEnvironmentApiGateWayUrl: string = 'https://a3xys3ni34.execute-api.us-east-1.amazonaws.com/prod';
    public static readonly devoEnvironmentApiGateWayUrl: string = 'https://i8u0lwuox5.execute-api.us-east-1.amazonaws.com/prod';
    public static readonly prodCognitoPoolId: string = 'us-east-1:75b15c0d-9815-4112-a6c2-9c534446ba4a';
    public static readonly devoCognitoPoolId: string = 'us-east-1:41ae304f-a620-423b-a5b2-c291adbaa6ff';

    // Cognito User Pool backing the *authenticated* identity. Empty means the stage
    // has no user pool yet, in which case the SPA falls back to the guest identity.
    // Populating these is what moves execute-api:Invoke off the unauthenticated role.
    public static readonly prodUserPoolId: string = 'us-east-1_12Emt6hx6';
    public static readonly prodUserPoolClientId: string = '3teheqrkk99gn9ii4il7ik2ovm';
    public static readonly devoUserPoolId: string = 'us-east-1_FnIEXJQ66';
    public static readonly devoUserPoolClientId: string = 'o6jqlv9nh7njmdklo6shahktc';

    public static get apiGatewayUrl(): string {
        if (Environment.isProd) {
            return Environment.prodEnvironmentApiGateWayUrl;
        } else {
            return Environment.devoEnvironmentApiGateWayUrl;
        }
    };

    public static get cognitoPoolId(): string {
        if (Environment.isProd) {
            return Environment.prodCognitoPoolId;
        } else {
            return Environment.devoCognitoPoolId;
        }
    };

    public static get userPoolId(): string {
        return Environment.isProd ? Environment.prodUserPoolId : Environment.devoUserPoolId;
    };

    public static get userPoolClientId(): string {
        return Environment.isProd ? Environment.prodUserPoolClientId : Environment.devoUserPoolClientId;
    };

    private static get isProd(): boolean {
        return Environment.hostField === Environment.prodEnvironmentBaseUrl
            || Environment.hostField === Environment.prodEnvironmentCloudFrontDomain
            || Environment.prodEnvironmentBaseUrlMarketingSite.includes(Environment.hostField);
    };
}